import { useState } from 'react';
import { Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { setModalState } from '../../../../../../reducer/Modal/actions';
import { MODAL_REMOVE_SELLER_REJECTION } from '../../../../../../reducer/Modal/types';
import { ZorbaButton } from '../../../../../../components/forms';
import { fetchDealSubmission } from '../../../../../../reducer/DealSubmission/actions';
import { postRequest } from '../../../../../../services/requestService';

import './index.scss';

export const RemoveSellerRejectionModal = ({ selectedDealSubmission }) => {
  const [isRemovingEvent, setIsRemovingEvent] = useState(false);
  const { isRemoveSellerRejectionModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const dispatch = useDispatch();
  const handleCloseModal = () => {
    dispatch(setModalState(MODAL_REMOVE_SELLER_REJECTION, false));
  };

  const handleRemoveEvent = async () => {
    const payload = {
      dealSubmissionId: selectedDealSubmission._id,
    };

    try {
      setIsRemovingEvent(true);
      await postRequest(
        '/backoffice/deal-submission/remove-seller-rejection',
        payload,
      );
      setIsRemovingEvent(false);
      handleCloseModal();
      dispatch(fetchDealSubmission(selectedDealSubmission._id));
    } catch (error) {
      setIsRemovingEvent(false);
    }
  };

  return (
    <Modal
      open={isRemoveSellerRejectionModalOpen}
      footer={null}
      onCancel={handleCloseModal}
      title="Remove the Seller Rejection Event"
      className="remove-seller-rejection-event-modal"
      destroyOnClose
    >
      <div className="instructions-container">
        <span>
          {`Are you sure you want to revert the "Seller rejected the deal" event?`}
        </span>
        <span>
          Reverting this action will move the deal back to the Pending Offer
          stage on both dashboards.
        </span>
        <span>The buyer will not receive any notifications.</span>
        <span className="instruction-bold">{`What's next:`}</span>
        <span>
          {`1. If you have confirmed with the buyer that the offer is still valid, click "Renew Offer" to allow the seller to accept the offer.`}
        </span>
        <span>
          {`2. You can also accept the offer on behalf of the seller by clicking "Accept Offer."`}
        </span>
      </div>
      <div className="button-container">
        <ZorbaButton
          fullWidth={false}
          onClick={handleRemoveEvent}
          disabled={isRemovingEvent}
          loading={isRemovingEvent}
        >
          Remove seller rejection event
        </ZorbaButton>
      </div>
    </Modal>
  );
};
